<div
	class="ic-form-field"
	[ngClass]="{
		'ic-form-field--focus': focus$ | async,
		'ic-form-field--not-empty': notEmpty$ | async,
		'ic-form-field--error': (error$ | async) || errors.length > 0,
		'ic-form-field--float': float,
	}"
>
	<label>
		<div class="ic-form-field__prefix"><ng-content select="[icPrefix]" /></div>

		<div class="ic-form-field__infix">
			<ng-content select="[icLabel]" />

			<ng-content select="[icInput]" />
		</div>

		<div class="ic-form-field__suffix"><ng-content select="[icSuffix]" /></div>
	</label>

	<div class="ic-form-field__errors"><ng-content select="ic-error" /></div>
</div>
